import AuthJobseeker from 'components/AuthJobseeker/AuthJobseeker';
import FAQ from 'components/FAQ/FAQ';
import WhyWorkersChooseJoblio from 'components/HeroComponents/WhyWorkersChooseJoblio';
import JobsCarousel from 'components/JobsCarousel/JobsCarousel';
import OurCLients from 'components/OurCLients/OurCLients';

const Jobseekers = () => {
  return (
    <>
      <WhyWorkersChooseJoblio componentToShowOnMobile={<OurCLients />} />
      <JobsCarousel />
      <FAQ />
      <AuthJobseeker />
    </>
  );
};

export default Jobseekers;
